import type { HotkeyItem as MantineHotkeyItem } from '@mantine/hooks';
import { getHotkeyHandler as mantineGetHotkeyHandler } from '@mantine/hooks';

export type Hotkey = 'Enter' | 'mod+Enter';

type HotkeyItem = [Hotkey, MantineHotkeyItem[1], MantineHotkeyItem[2]] | [Hotkey, MantineHotkeyItem[1]];

export const getHotkeyHandler = (hotkeys: HotkeyItem[]) => mantineGetHotkeyHandler(hotkeys);
